/**
 * Add target="_blank" attribute to all links in the given text
 * @returns {Function}
 */
export function LinkTargetBlankFilter() {
  return function linkTargetBlank(input) {
    return input && input.replace ?
      input.replace(/<(a )([^>]+)>/gi, '<$1 target="_blank" $2>') :
      input;
  };
}
